import { Box, Divider, Button, Text, useMediaQuery } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import CalendarIcon from "public/images/calendar.svg";
import ConferenceIcon from "public/images/conference.svg";
import GoIcon from "public/images/go-arrow.svg";
import LocationPinIcon from "public/images/location-pin.svg";
import successBanner from "public/images/tbw-banner/success-page.png";
import checkoutBanner from "public/images/tbw-banner/checkout-page.png";
import OrderSummary from "components/TicketingModal/TicketingModalOrderSummary";
import tbwCheckoutBanner from "public/images/tbw-banner/checkout-page.png";
import full from "public/images/astra/full.png";
import corporate from "public/images/astra/corporate.png";
import founding from "public/images/astra/founding.png";
import { useAtom } from "jotai";
import { selectedTicketAtom } from "utils/atoms";
import { TicketID } from "utils/mongo/tickets.model";

const PaymentSuccess = () => {
  const t = useTranslations("paymentSuccess");
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [selectedTicket, setSelectedTicket] = useAtom(selectedTicketAtom);

  return (
    <div className="flex flex-col justify-center items-center p-4 sm:py-16 sm:flex-row-reverse relative p-4">
      <div className="w-[0%] max-w-[510px] md:flex bg-neutral-800 md:w-[42.5%] flex-col hidden sm:mx-16">
        <div className=" overflow-hidden">
          <Image src={tbwCheckoutBanner} alt="Astra Club" />
        </div>
        <OrderSummary />
      </div>

      <div className="flex flex-col items-center h-full rounded-3xl overflow-hidden w-full sm:items-start sm:ml-16 sm:max-w-max">
        <div className="p-4 flex-col flex sm:items-start items-center">
          <p className="text-lg sm:text-3xl text-center font-medium mt-10  text-neutral-300">
            Congrats, thanks for your order! 🎉
          </p>

          <p className="text-4xl sm:text-5xl font-bold max-w-xl py-8 sm:py-10 sm:pt-20">
            The Astra Club
          </p>

          <Text
            color="neutral.300"
            fontSize="lg"
            mb={["", "3rem"]}
            maxW="75ch"
            textAlign={["center", "left"]}
          >
            An exclusive club created to reward our closest partners, friends,
            and early adopters of Moongate. By invitation only.
            <br />
            <br />
            Join our &nbsp;
            <span className="text-primary font-bold">
              <a
                target="_blank"
                href={"https://discord.com/invite/KpvCUD5NgM"}
                rel="noopener noreferrer"
              >
                Discord
              </a>
            </span>
            &nbsp; server and follow us on &nbsp;
            <span className="text-primary font-bold">
              <a
                target="_blank"
                href={"https://twitter.com/0xmoongate"}
                rel="noopener noreferrer"
              >
                Twitter
              </a>
            </span>
            &nbsp; to learn more about upcoming drops and requirements!
          </Text>
        </div>

        <div className="flex-col flex items-center sm:flex-row sm:items-start gap-1">
          <div className="flex-col flex items-center p-4 sm:items-start gap-2">
            <p className="text-secondary text-base font-semibold text-neutral-300">
              YOUR CLAIMED NFT(S)
            </p>
            <div className="rounded-xl overflow-hidden w-[227px]  ">
              {selectedTicket?.ticket.id === TicketID.FULL && (
                <Image src={full} alt="Astra Club Full" />
              )}
              {selectedTicket?.ticket.id === TicketID.FOUNDING && (
                <Image src={founding} alt="Astra Club founding" />
              )}
              {selectedTicket?.ticket.id === TicketID.CORPORATE && (
                <Image src={corporate} alt="Astra Club corporate" />
              )}
            </div>
            <p className="text-text-primary text-base font-medium text-neutral-600"></p>
          </div>

          <div className="flex flex-col  items-center justify-evenly sm:gap-8 w-full relative sm:ml-[8.25rem]">
            <div className="flex flex-col items-center gap-1  w-full p-4 text-center sm:items-start">
              <p className="text-secondary text-base font-semibold text-neutral-300">
                {t("location")}
              </p>
              <p className="text-text-primary text-base font-medium text-neutral-600">
                The Astra Club
              </p>
            </div>

            <div className="flex flex-col items-center gap-1  w-full p-4  text-center sm:items-start">
              <p className="text-secondary text-base font-semibold text-neutral-300">
                {t("dateTime")}
              </p>
              <p className="text-text-primary text-base font-medium text-neutral-600">
                <>Working Hours 16:00 - 03:00</>
              </p>
            </div>
          </div>
        </div>

        <a
          className="w-fit"
          href="https://app.moongate.id"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            variant="gradient"
            marginBottom={["2rem", "1rem"]}
            marginTop={["2rem", "4rem"]}
          >
            <p>See My NFT</p>
          </Button>
        </a>
      </div>
    </div>
  );
};

export default PaymentSuccess;
